<template>
  <div class="footer">
    <!-- <div class="footer-language"><span class="chinese" @click="changeLocale('zh-TW')">繁體中文</span><span> | </span><span class="en" @click="changeLocale('en')" >english</span></div> -->
    <div class="footer-description">
      <span class="footer-description-text">© 2021 Berryan Ltd.</span>
      <span class="footer-description-link">
        <router-link
          class="footer-description-link-item"
          :to="`${root}/public/terms`"
          >服務條款</router-link
        >
        <router-link
          class="footer-description-link-item"
          :to="`${root}/public/privacy`"
          >隱私權政策</router-link
        >
        <button
          type="button"
          class="footer-description-link-item"
          @click="openConnectionDialog"
        >
          聯絡我們
        </button>
      </span>
    </div>
    <el-dialog class="connection-dialog" :visible.sync="isConnectionOpen">
      <div slot="title">聯絡我們</div>
      <div class="connection-dialog__body">
        <div class="connection-dialog__body-item">
          <div class="connection-dialog__body-item-label">信箱</div>
          <a
            href="mailto: service@berryan.com"
            class="connection-dialog__body-item-value"
            >service@berryan.com</a
          >
        </div>
        <div class="connection-dialog__body-item">
          <div class="connection-dialog__body-item-label">電話</div>
          <a href="tel: 0226968766" class="connection-dialog__body-item-value"
            >02-26968766</a
          >
        </div>
      </div>
      <div slot="footer">
        <button
          type="button"
          class="connection-dialog__footer-button main-button"
          @click="closeConnectionDialog()"
        >
          確認
        </button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    name: "pacaFooter",
    data() {
      return {
        root: process.env.VUE_APP_PACACLOUND_ROOT,
        isConnectionOpen: false,
      };
    },
    methods: {
      changeLocale(locale) {
        this.$message.success({
          duraction: 2500,
          showClose: true,
          message: this.$t("footer.changeLanguage"),
        });
        this.$i18n.locale = locale;
      },
      openConnectionDialog() {
        this.isConnectionOpen = true;
      },
      closeConnectionDialog() {
        this.isConnectionOpen = false;
      },
    },
  };
</script>
